{
  "authenticate": "Authentifizieren"
}
